export default {
    rightsReserved: 'All rights reserved',
    generalConditionsLink: '/general-conditions',
    generalConditions: 'General conditions',
    frequentQuestionsLink: '/help',
    frequentQuestions: 'Frecuently Asked Questions',
    regretButton: 'Right of withdrawal',
    regretButtonLink: 'https://p10-cdn.s3.amazonaws.com/p10botondearrepentimiento.pdf',
}